import Vue from "vue";

import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import config from "config";
import VueAxios from "vue-axios";
import VueAuth from "@websanova/vue-auth";
import Buefy from "buefy/src";
import Vue2Filters from "vue2-filters";
import VeeValidate from "vee-validate";
import ptBR from "vee-validate/dist/locale/pt_BR";
import { format as dateFormat } from "date-fns";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUserSecret,
  faSyncAlt,
  faCalendar,
  faSadTear,
  faSortUp,
  faCaretLeft,
  faCaretRight,
  faAngleRight,
  faAngleLeft,
  faAngleUp,
  faAngleDown,
  faEye,
  faEyeSlash,
  faBarcode,
  faTrash,
  faExclamationCircle,
  faCar,
  faUser,
  faUserFriends,
  faInfoCircle,
  faFileAlt,
  faKeyboard,
  faExternalLinkAlt,
  faEnvelope,
  faTimes,
  faLock,
  faQrcode,
  faMapMarkedAlt,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import { faSmile } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import vSelect from "vue-select";
import VueClipboard from "vue-clipboard2";

import App from "./App.vue";

import auth from "./services/auth";
import API from "./services/http";
import router from "./services/router";
import store from "./services/store";
import validator from "./services/validator";
import VueCan from "./services/VueCan";

library.add(
  faSmile,
  faUserSecret,
  faSyncAlt,
  faCalendar,
  faSadTear,
  faSortUp,
  faCaretLeft,
  faCaretRight,
  faAngleRight,
  faAngleLeft,
  faAngleUp,
  faAngleDown,
  faEye,
  faEyeSlash,
  faExclamationCircle,
  faBarcode,
  faTrash,
  faCar,
  faUser,
  faUserFriends,
  faInfoCircle,
  faFileAlt,
  faKeyboard,
  faExternalLinkAlt,
  faEnvelope,
  faTimes,
  faLock,
  faQrcode,
  faMapMarkedAlt,
  faCheck
);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("v-select", vSelect);
Vue.use(VueClipboard);

Vue.use(Vue2Filters);
Vue.use(Buefy, {
  defaultDateFormatter: (date) => {
    const targetDates = Array.isArray(date) ? date : [date];
    const dates = targetDates.map((date) =>
      dateFormat(new Date(date), "dd/MM/yyyy")
    );
    return dates.join(", ");
  },
  defaultIconComponent: "font-awesome-icon",
  defaultIconPack: "fas",
});

Vue.use(VeeValidate);
validator.localize("pt_BR", ptBR);

Vue.use(VueAxios, API);

// Declare $router to fix $auth setup
Vue.router = router;
Vue.use(VueAuth, auth);

Vue.use(VueCan);

Sentry.init({
  dsn: config.SENTRY_DSN,
  integrations: [
    new VueIntegration({ Vue, attachProps: true, logErrors: true }),
  ],
  environment: config.SENTRY_ENV || config.env,
  release: process.env.VUE_APP_RELEASE_VERSION,
});

// Sentry.configureScope((scope) => {
//   scope.setExtra('city', Vue.prototype.app.city)
// })

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

function applyConsentScript() {
  const script = document.createElement("script");

  script.setAttribute("id", "zul-consent-script");
  script.setAttribute("type", "text/javascript");
  script.setAttribute("src", config.CONSENT_SCRIPT_URL);

  script.async = true;

  const tag = document.getElementsByTagName("script")[0];
  tag.parentNode.insertBefore(script, tag);
}

applyConsentScript();
